
import React from "react";
import { Card } from "@/components/ui/card";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";

interface TickerSettingsProps {
  speed: number;
  onSpeedChange: (value: number) => void;
  backgroundColor: string;
  onBackgroundColorChange: (color: string) => void;
  textColor: string;
  onTextColorChange: (color: string) => void;
}

export const TickerSettings: React.FC<TickerSettingsProps> = ({
  speed,
  onSpeedChange,
  backgroundColor,
  onBackgroundColorChange,
  textColor,
  onTextColorChange,
}) => {
  const handleSpeedChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = parseInt(e.target.value, 10);
    if (!isNaN(newValue) && newValue >= 1 && newValue <= 50) {
      console.log('Updating speed to:', newValue);
      onSpeedChange(newValue);
    }
  };

  return (
    <Card className="p-4 space-y-6 bg-black/20 border-white/10 text-white">
      <div className="space-y-2">
        <Label htmlFor="speed">Message Speed (1-50 seconds)</Label>
        <Input
          id="speed"
          type="number"
          min={1}
          max={50}
          value={speed}
          onChange={handleSpeedChange}
          className="bg-black/50 text-white border-white/20"
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="bgColor">Background Color</Label>
        <div className="flex items-center gap-2">
          <Input
            id="bgColor"
            type="color"
            value={backgroundColor}
            onChange={(e) => onBackgroundColorChange(e.target.value)}
            className="w-12 h-12 p-1 bg-transparent cursor-pointer [&::-webkit-color-swatch]:rounded-full [&::-webkit-color-swatch-wrapper]:p-0.5 [&::-webkit-color-swatch]:border-2"
          />
          <Input
            type="text"
            value={backgroundColor}
            onChange={(e) => onBackgroundColorChange(e.target.value)}
            className="flex-1 bg-black/50 text-white border-white/20"
          />
        </div>
      </div>

      <div className="space-y-2">
        <Label htmlFor="textColor">Text Color</Label>
        <div className="flex items-center gap-2">
          <Input
            id="textColor"
            type="color"
            value={textColor}
            onChange={(e) => onTextColorChange(e.target.value)}
            className="w-12 h-12 p-1 bg-transparent cursor-pointer [&::-webkit-color-swatch]:rounded-full [&::-webkit-color-swatch-wrapper]:p-0.5 [&::-webkit-color-swatch]:border-2"
          />
          <Input
            type="text"
            value={textColor}
            onChange={(e) => onTextColorChange(e.target.value)}
            className="flex-1 bg-black/50 text-white border-white/20"
          />
        </div>
      </div>
    </Card>
  );
};
